/* Constants */
import { ChartType } from "src/shared/constants/charts/Chart";

/* Factories */
import { createStackedLayout } from "src/utils/layout/stacked-layout/factories/stackedLayoutFactory";

/* Interfaces */
import { BaseChartProps } from "src/shared/interfaces/charts/BaseChart";
import { DescriptiveStatisticsProps } from "src/shared/interfaces/DescriptiveStatistics";
import { SurvivalAnalysisProps } from "src/shared/interfaces/SurvivalAnalysis";
import { LayoutProps } from "src/shared/interfaces/common/Layout";

export const getStackedLayout = (
  type: ChartType[],
  data: BaseChartProps<
    DescriptiveStatisticsProps | SurvivalAnalysisProps,
    ChartType[]
  >,
  featureOrCohort?: string,
  showNoValueEntries?: boolean
): LayoutProps => {
  /**
   * Create `uniqueTypes` for stacked layout.
   */
  const uniqueTypes = [...new Set(type)];
  const rows = uniqueTypes.map((type, index) => {
    return {
      cols: createStackedLayout(
        index,
        type,
        data,
        featureOrCohort,
        showNoValueEntries
      ),
    };
  });

  return { rows };
};
